module.exports = __webpack_public_path__ + "img/invoice-de-female-wm-mv.69bbfb09.png";